import React from 'react'
import { addLocaleData } from 'react-intl'
import localeData from 'react-intl/locale-data/it'

import Layout from './index'
import messages from '../i18n/it.json'

addLocaleData(localeData)

export default props => {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem('locale', 'it')
  }

  return <Layout {...props} locale="it" messages={messages} />
}

export const query = graphql`
  query AllImagesIT {
    allImageSharp {
      edges {
        node {
          sizes {
            base64
            aspectRatio
            src
            srcSet
            sizes
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/it.js